import {
	SET_NIGHT_THEME_FULFILLED,
	SET_DAY_THEME_FULFILLED
} from '../constants/theme.actions';

export const setNightTheme = () => ({
	type: SET_NIGHT_THEME_FULFILLED,
	payload: null
});

export const setDayTheme = () => ({
	type: SET_DAY_THEME_FULFILLED,
	payload: null
});
